// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__QEWo7","buttonDisabled":"styles_buttonDisabled__zitrt"};